import React, { ReactNode } from 'react';
import styled, { css, ISpruceThemeProps } from 'styled-components';
import { IHasTestData } from '../../test-utilities/IHasTestData';

export interface ITextTagProps extends IHasTestData, React.HTMLAttributes<HTMLDivElement> {
  text: ReactNode;
  type: StyledTagType;
}

export type StyledTagType = 'pink' | 'blue' | 'purple' | 'yellow' | 'gray' | 'green' | 'error';

interface IStyledTagProps {
  type: StyledTagType;
}

const typeToColor = (x: IStyledTagProps & ISpruceThemeProps) => {
  switch (x.type) {
    case 'blue':
    case 'pink':
    case 'green':
    case 'error':
    case 'purple':
      return x.theme.colors.white;
    case 'gray':
    case 'yellow':
    default:
      return x.theme.colors.black;
  }
};

const typeToBackgroundColor = (x: IStyledTagProps & ISpruceThemeProps) => {
  switch (x.type) {
    case 'blue':
      return x.theme.colors.blue;
    case 'pink':
      return x.theme.colors.pink;
    case 'purple':
      return x.theme.colors.purple;
    case 'yellow':
      return x.theme.colors.yellow;
    case 'green':
      return x.theme.colors.primary;
    case 'error':
      return x.theme.colors.error;
    case 'gray':
    default:
      return x.theme.colors.lightGray;
  }
};
const typeToBorderColor = (x: IStyledTagProps & ISpruceThemeProps) => {
  switch (x.type) {
    case 'blue':
      return x.theme.colors.blue;
    case 'pink':
      return x.theme.colors.pink;
    case 'purple':
      return x.theme.colors.purple;
    case 'yellow':
      return x.theme.colors.yellow;
    case 'green':
      return x.theme.colors.primary;
    case 'error':
      return x.theme.colors.error;
    case 'gray':
    default:
      return x.theme.colors.gray;
  }
};

const version2Styles = css<IStyledTagProps>`
  color: ${typeToColor};
  background-color: ${typeToBackgroundColor};
  border: 1px solid ${typeToBorderColor};
  padding: ${(props) => props.theme.spacing.spacing4};
  padding-top: ${(props) => props.theme.spacing.spacing2};
  padding-bottom: ${(props) => props.theme.spacing.spacing2};
  border-radius: 12px;
  ${(props) => props.theme.fonts.mixins.tiny}
`;
const StyledTag = styled.div<IStyledTagProps>`
  ${version2Styles}
`;

export const TextTag: React.FC<ITextTagProps> = ({ text, ...rest }) => {
  return <StyledTag {...rest}>{text}</StyledTag>;
};
